import { render, staticRenderFns } from "./BlendEditorCol.vue?vue&type=template&id=0f8f7612&scoped=true"
import script from "./BlendEditorCol.vue?vue&type=script&lang=js"
export * from "./BlendEditorCol.vue?vue&type=script&lang=js"
import style0 from "./BlendEditorCol.vue?vue&type=style&index=0&id=0f8f7612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f7612",
  null
  
)

export default component.exports